import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FirebaseAuthService } from '../firebase/firebase-auth.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private endpoint = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private firebaseAuth: FirebaseAuthService,
  ) {}

  login(email: string, password: string, remember = true): Observable<string> {
    return this.firebaseAuth.signIn(email, password, remember);
  }

  logout(): Observable<void> {
    return this.firebaseAuth.signOut();
  }

  forgotPassword(email: string): Observable<void> {
    return this.http.post<void>(`${this.endpoint}/auth/forgot-password`, { email });
  }

  resetPassword(_id: string, newPassword: string, token: string): Observable<void> {
    return this.http.post<void>(`${this.endpoint}/auth/reset-password`, { _id, newPassword, token });
  }
}
